export default "__VITE_ASSET__10d903ce__"